import { Component } from '@angular/core';

@Component({
  selector: 'icon-close',
  standalone: true,
  template: `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_29_382" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
            <rect x="4" y="4" width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_29_382)">
            <path d="M10.4 23L9 21.6L14.6 16L9 10.4L10.4 9L16 14.6L21.6 9L23 10.4L17.4 16L23 21.6L21.6 23L16 17.4L10.4 23Z" fill="#1C6E70"/>
        </g>
    </svg>
  `,
  styles: [
   `
    svg {
        path {
          fill: #000;
        }
      }

    svg:hover {
        path {
          fill: var(--main-color);
        }
      }
    `
  ]
})

export class CloseIconComponent {

}
